/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export var ToastType;
(function (ToastType) {
    ToastType["ERROR"] = "ERROR";
    ToastType["WARNING"] = "WARNING";
    ToastType["SUCCESS"] = "SUCCESS";
    ToastType["INFO"] = "INFO";
})(ToastType || (ToastType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9hc3QtdHlwZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zaGFyZWQvdG9hc3RzL3RvYXN0LXR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxTQUtYO0FBTEQsV0FBWSxTQUFTO0lBQ2pCLDRCQUFlLENBQUE7SUFDZixnQ0FBbUIsQ0FBQTtJQUNuQixnQ0FBbUIsQ0FBQTtJQUNuQiwwQkFBYSxDQUFBO0FBQ2pCLENBQUMsRUFMVyxTQUFTLEtBQVQsU0FBUyxRQUtwQiJ9